export const PLUGIN_VERSION_QUERY = {sanityVersion: process.env.PKG_VERSION!}
